import React from 'react';

import NodeTag from 'pages/item/v2/components/CpeConfigurations/components/NodeTag';

import useStyles from './styles';

import { NodeItem, Operator } from '../../types';
import Node from '../Node';
import OperatorTag from '../OperatorTag';

interface Props {
    operator: Operator;
    data: NodeItem[];
    className?: string;
}

const CpeConfiguration: React.FC<Props> = ({ operator, data, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <NodeTag className={classes.caption} />
            <div className={classes.container}>
                <div className={classes.line} />
                <div className={classes.items}>
                    {data.map((item, index) => (
                        <React.Fragment key={index}>
                            {index === 0 ? null : (
                                <OperatorTag label={operator} className={classes.operator} color="red" />
                            )}
                            <Node key={index} operator={item.operator} data={item.cpeMatch} />
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CpeConfiguration;
